import React, { useEffect, useState } from "react";

const Celendar = ({ active }) => {
  return (
    <svg
      className="w-6 h-6"
      viewBox="0 0 24 23"
      xmlns="http://www.w3.org/2000/svg"
      fill={active ? "#BA004F" : "#C1A4A4"}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9999 -0.000366211H0.999837C0.447498 -0.000366211 0 0.447321 0 0.999822C0 1.55194 0.447498 2.00001 0.999837 2.00001H22.9999C23.5522 2.00001 24 1.55194 24 0.999822C24 0.447321 23.5522 -0.000366211 22.9999 -0.000366211ZM22.0001 4.99947H1.99994C0.895293 4.99947 0 5.89525 0 6.99987V20.9996C0 22.1046 0.895293 23 1.99994 23H22.0001C23.1045 23 24 22.1046 24 20.9996V6.99987C24 5.89525 23.1045 4.99947 22.0001 4.99947ZM1.99994 6.99987H22.0001V20.9996H1.99994V6.99987ZM6.99991 10.4998C6.99991 9.67141 6.32837 8.99987 5.49987 8.99987C4.6714 8.99987 3.99986 9.67141 3.99986 10.4998C3.99986 11.3281 4.6714 11.9997 5.49987 11.9997C6.32837 11.9997 6.99991 11.3281 6.99991 10.4998Z"
      />
    </svg>
  );
};

export default Celendar;
